import React from "react";
import { Title } from "../Title";
import { WHY_CHOOSE_US_LIST } from "../../common";
import { WhyChooseUsItem } from "../WhyChooseUsItem";
import style from "./WhyChooseUsList.module.css";

export const WhyChooseUsList = () => {
  return (
    <div className={"container"}>
      <Title title="Why choose us" mt="var(--section-spacing)" />
      <div className={style.cardList}>
        {WHY_CHOOSE_US_LIST.map((card) => (
          <WhyChooseUsItem key={card.id} card={card} />
        ))}
      </div>
    </div>
  );
};
